<template>
  <v-menu>
    <template #activator="{ props: menuProps }">
      <!-- We use a bare v-tooltip here because AppTooltip has trouble when combined with another activator -->
      <v-tooltip location="top" transition="fade-transition">
        <template #activator="{ props: tooltipProps }">
          <app-button
            class="additional-actions-button"
            data-locator="other-actions-menu-button"
            type="icon"
            v-bind="{ ...menuProps, ...tooltipProps }"
          >
            <app-material-icon name="more_horiz" />
          </app-button>
        </template>
        <span>{{ $t('common.additionalActions') }}</span>
      </v-tooltip>
    </template>
    <v-list data-locator="checklist-section-menu">
      <v-list-item
        link
        data-locator="collapse-section-menu-item"
        @click="$emit('collapse-section')"
      >
        <v-list-item-title class="d-flex align-center column-gap-2">
          <app-material-icon
            name="collapse_all"
          />
          <span class="text-text-secondary">{{ t('collapseSection') }}</span>
        </v-list-item-title>
      </v-list-item>
      <v-list-item
        link
        data-locator="expand-section-menu-item"
        @click="$emit('expand-section')"
      >
        <v-list-item-title class="d-flex align-center column-gap-2">
          <app-material-icon
            name="expand_all"
          />
          <span class="text-text-secondary">{{ t('expandSection') }}</span>
        </v-list-item-title>
      </v-list-item>
      <v-list-item
        link
        data-locator="select-all-menu-item"
        @click="$emit('select-all')"
      >
        <v-list-item-title class="d-flex align-center column-gap-2">
          <app-material-icon
            name="check_box"
          />
          <span class="text-text-secondary">{{ t('selectAll') }}</span>
        </v-list-item-title>
      </v-list-item>
      <template v-if="isCurrentUserPm">
        <v-divider class="mx-2 my-1 text-border-primary" :opacity="1" />
        <v-list-item
          link
          data-locator="rename-menu-item"
          @click="$emit('rename-section')"
          class="rename-button"
        >
          <v-list-item-title class="rename-button d-flex align-center column-gap-2">
            <app-material-icon
              name="edit"
            />
            <span class="rename-button text-text-secondary">{{ t('rename') }}</span>
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          link
          data-locator="delete-menu-item"
          @click="$emit('delete-section')"
          class="text-text-danger"
        >
          <v-list-item-title class="d-flex align-center column-gap-2">
            <app-material-icon
              name="delete"
              color="icon-danger"
            />
            {{ $t('common.delete') }}
          </v-list-item-title>
        </v-list-item>
      </template>
    </v-list>
  </v-menu>
</template>

<script lang="ts">
import { mapGetters } from 'vuex';

import { useTranslation } from '@/common/utils/translation'

export default {
  name: 'ChecklistTableSectionMenu',
  setup () {
    return useTranslation({ keyPrefix: 'project.checklist.table.ChecklistTableSectionMenu' })
  },
  computed: {
    ...mapGetters('room', ['isCurrentUserPm']),
  },
}
</script>
<style scoped lang="scss">
.v-list-item-title {
  display: flex;
  align-items: center;
}

.additional-actions-button.app-button.app-button--icon {
  min-width: 28px;
  min-height: 28px;
  height: 28px;
  &:not(:disabled):hover {
    background-color: rgb(var(--v-theme-surface-tertiary));
  }
}
</style>
